import type { MarkNotificationAsRead200BasicInfoType } from './markNotificationAsRead200BasicInfoType';

export type MarkNotificationAsRead200BasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: MarkNotificationAsRead200BasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
